<template>
    <div style="background-color: whitesmoke; overflow-x: auto;" > 
        <!-- <CCardBody class="" style="min-width: 1000px; max-height: 600px;"> -->
        <div>
            <h5>{{ $t('Chart and stats') }}</h5>
            <label style="color: red; font-weight: bold;">{{ $t("Market") }}:</label>
            <CSelect
                style="width: 200px;"
                class="league-list"
                :options="markets"
                :value.sync="market"
            >
            </CSelect>
        </div>
        <CCardBody class="financial-chart-body">
            <CRow>
                <CCol :sm="3">
                    <CCard>
                        <CCardBody>
                            <CCardTitle class="text-center"><p style="font-size: 20px;">{{ $t("Total sample") }}</p></CCardTitle>
                            <CCardText class="text-center p_label">{{ marketStats.total_matches }}</CCardText>
                        </CCardBody>
                    </CCard>
                </CCol>
                <CCol :sm="3">
                    <CCard>
                        <CCardBody>
                            <CCardTitle class="text-center"><p style="font-size: 20px;">{{ $t("Operations per month") }}</p></CCardTitle>
                            <CCardText class="text-center p_label">{{ marketStats.operations_per_month }}</CCardText>
                        </CCardBody>
                    </CCard>
                </CCol>
                <CCol :sm="3">
                    <CCard>
                        <CCardBody>
                            <CCardTitle class="text-center"><p style="font-size: 20px;">{{ $t("Avg Odd") }}</p></CCardTitle>
                            <CCardText class="text-center p_label">{{ marketStats.avg_odds }}</CCardText>
                        </CCardBody>
                    </CCard>
                </CCol>
                
            </CRow>
            <CRow>
                <CCol :sm="3">
                    <CCard>
                        <CCardBody style="text-align: center;">
                            <CCardTitle class="text-center"><p style="font-size: 20px;">{{ $t("Win/Rate") }}</p></CCardTitle>
                            <!-- <CCardText v-if="marketStats.win_rate && marketStats.win_rate >= 50" class="positive-mark-odd">{{ marketStats.win_rate + "%" }}</CCardText>
                            <CCardText v-else-if="marketStats.win_rate && marketStats.win_rate < 50" class="negative-mark-odd">{{ marketStats.win_rate + "%" }}</CCardText> -->

                            <CCardText v-if="marketStats.win_rate" class="text-center p_label">{{ marketStats.win_rate + "%" }}</CCardText>
                        </CCardBody>
                    </CCard>
                </CCol>
                <CCol :sm="3">
                    <CCard>
                        <CCardBody style="text-align: center;">
                            <CCardTitle class="text-center"><p style="font-size: 20px;">{{ $t("Profit PTS") }}</p></CCardTitle>
                            
                            <CCardText v-if="marketStats.profit_pts && marketStats.profit_pts > 0" class="positive-mark-odd">{{ marketStats.profit_pts }}</CCardText>
                            <CCardText v-else-if="marketStats.profit_pts && marketStats.profit_pts < 0" class="negative-mark-odd">{{ marketStats.profit_pts }}</CCardText>
                        </CCardBody>
                    </CCard>
                </CCol>
                <CCol :sm="3">
                    <CCard>
                        <CCardBody style="text-align: center;">
                            <CCardTitle class="text-center"><p style="font-size: 20px;">{{ $t("ROI") }}</p></CCardTitle>                            
                            <CCardText v-if="marketStats.roi && marketStats.roi > 0" class="positive-mark-odd">{{ marketStats.roi + "%" }}</CCardText>
                            <CCardText v-else-if="marketStats.roi && marketStats.roi < 0" class="negative-mark-odd">{{ marketStats.roi + "%" }}</CCardText>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
            
            <CChartLine
                type      = "line"
                :wrapper  = "false"
                :labels   = "daily_labels"
                :datasets = "daily_datasets"
                :options = "options"
            />
       
            <CChartBar
                type      = "bar"
                :wrapper  = "false"
                :labels   = "monthly_labels"
                :datasets = "monthly_datasets"
                :options = "options"
            />
        </CCardBody>
    </div>
</template>

<script>
import { CChartLine  } from '@coreui/vue-chartjs';
import { CChartBar } from '@coreui/vue-chartjs'

export default {
    name: 'SearchStatsOddsChart',
    components: {
        CChartLine,
        CChartBar
    },
    props: {
        items: {
            type: Array,
            default: () => []
        },
    },
    data () {
        return {
            daily_datasets: [
                {
                    fill: false,
                    tension: 0.1,
                    label: this.$t('Home - FT'),
                    borderColor: '#00D8FF',
                    data: []
                },
            ],
            monthly_datasets: [
                {
                    fill: false,
                    tension: 0.1,
                    label: this.$t('Home - FT'),
                    backgroundColor: '#00D8FF',
                    data: []
                },
            ],
            options: {
                maintainAspectRatio: false,
                // aspectRatio: 1, 
                scales: {
                  yAxes: [{
                    ticks: {
                      callback: (val) => (`${val}`)
                    }
                  }]
                }
            },
            market: 'Home - FT',
            markets: [
                { label: this.$t('Home - FT'), value: 'Home - FT'},
                { label: this.$t('Away - FT'), value: 'Away - FT'},
                { label: this.$t('Draw - FT'), value: 'Draw - FT'},
                { label: this.$t('Home - HT'), value: 'Home - HT'},
                { label: this.$t('Away - HT'), value: 'Away - HT'},
                { label: this.$t('Draw - HT'), value: 'Draw - HT'},
                { label: this.$t('Over - 0.5 - FT'), value: 'Over - 0.5 - FT'},
                { label: this.$t('Over - 1.5 - FT'), value: 'Over - 1.5 - FT'},
                { label: this.$t('Over - 2.5 - FT'), value: 'Over - 2.5 - FT'},
                { label: this.$t('Over - 3.5 - FT'), value: 'Over - 3.5 - FT'},
                { label: this.$t('Under - 0.5 - FT'), value: 'Under - 0.5 - FT'},
                { label: this.$t('Under - 1.5 - FT'), value: 'Under - 1.5 - FT'},
                { label: this.$t('Under - 2.5 - FT'), value: 'Under - 2.5 - FT'},
                { label: this.$t('Under - 3.5 - FT'), value: 'Under - 3.5 - FT'},
                { label: this.$t('Over - 0.5 - HT'), value: 'Over - 0.5 - HT'},
                { label: this.$t('Over - 1.5 - HT'), value: 'Over - 1.5 - HT'},
                { label: this.$t('Under - 0.5 - HT'), value: 'Under - 0.5 - HT'},
                { label: this.$t('Under - 1.5 - HT'), value: 'Under - 1.5 - HT'},
                { label: this.$t('BTS - FT'), value: 'BTS - FT'},
                { label: this.$t('No BTS - FT'), value: 'No BTS - FT'},
                { label: this.$t('1X'), value: '1X'},
                { label: this.$t('X2'), value: 'X2'},
                { label: this.$t('12'), value: '12'},
            ],
            marketStats: {
                'total_matches': "",
                'operations_per_month': "",
                'win_rate': "",
                'avg_odds': "",
                'profit_pts': "",
                'roi': "",
            }

        }
    },
    created() {
        this.init();
        
    },
    computed: {
        daily_labels() {
            
            let labels = [];            
            let data = [];

            let marketData = this.items.filter( item => item.market == this.market);
            if ( marketData.length > 0 && marketData[0].rows_by_date.length > 0 ) {
                labels = marketData[0].rows_by_date.map(({date})=>date);
                data = marketData[0].rows_by_date.map(({profit})=>profit);
            }            
            this.daily_datasets[0].data = data;
            this.daily_datasets[0].label = this.$t(this.market);

            if ( marketData.length > 0 ){
                this.marketStats = {
                    'total_matches': marketData[0].total_matches.length,
                    'operations_per_month': marketData[0].operations_per_month,
                    'win_rate': marketData[0].win_rate,
                    'avg_odds': marketData[0].avg_odds,
                    'profit_pts': marketData[0].profit_pts,
                    'roi': marketData[0].roi,
                };
            }

            return labels;
        },
        monthly_labels() {
            
            let labels = [];            
            let data = [];

            let marketData = this.items.filter( item => item.market == this.market);
            if ( marketData.length > 0 && marketData[0].rows_by_month.length > 0 ) {
                labels = marketData[0].rows_by_month.map(({month})=>month);
                data = marketData[0].rows_by_month.map(({profit})=>profit);
            }            
            this.monthly_datasets[0].data = data;
            this.monthly_datasets[0].label = this.$t(this.market);
            return labels;
        }
    },
    mounted: function (){
        this.$nextTick(function () {
            console.log('==============  mounted function')
            

        })
    },
    methods: {
        init() {
            console.log('items======>>>>>>>>', this.items)
        },
        showModal() {
            // this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow')

            console.log('show modal')
            this.$bvModal.show('modal-1')
            console.log('show modal close')
        },
        hideModal() {
            this.$root.$emit('bv::hide::modal', 'modal-1', '#btnShow')
        },
    }
}
</script>

<style>
    .p_label {
        font-size: 15px;
        font-weight: bold;
    }
    .green-background {
        background-color:  green;
    }
    .red-background {
        background-color:  red;
    }
    .positive-mark-odd {
        display: inline-block;
        background-color: green;
        color:  white;
        font-size: 15px;
        font-weight: bold;
        padding-left: 5px;
        padding-right: 5px;
        border-radius: 5px;
    }
    .negative-mark-odd {
        display: inline-block;
        background-color: red;
        color:  white;
        font-size: 15px;
        font-weight: bold;
        padding-left: 5px;
        padding-right: 5px;
        border-radius: 5px;
    }
    /*canvas.chartjs-render-monitor {
        max-height: 600px !important;
        max-width: 1200px !important;

    }*/
    canvas.chartjs-render-monitor {
        height: 500px !important;
    }
    @media (max-width: 1800px) {
       
        canvas.chartjs-render-monitor {
            height: 450px !important;
        }
        
    }
    @media (max-width: 1200px) {
       
        canvas.chartjs-render-monitor {
            height: 400px !important;
        }
        
    }
    @media (max-width: 576px) {
        
        canvas.chartjs-render-monitor {
            height: 350px !important;
        }    
    }
</style>